import "./new.css";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { useState } from "react";
import axios from 'axios'
import { useNavigate } from "react-router-dom";
import { userInputs } from "../../formSource";

const New = ({inputs, title}) => {
  const [file, setFile] = useState("")
  const [info, setInfo] = useState({});

  const handleChange = e => {
    setInfo(prev => ({...prev, [e.target.id]: e.target.value}))
  };

  const handleReset = () => {
    setInfo({});
    setFile("");
  };

  const navigate = useNavigate()

  const handleClick = async e => {
    e.preventDefault()
    try {
      const newUser = {
        ...info,
        isAdmin: info.isAdmin === 'true'
      };
      await axios.post("https://api.moroccool.com/api/auth/register", newUser)
    } catch (err) {
      console.log(err)
    }
    navigate("/users")
  }

  return (
    <div className="user-creation-layout">
      <Sidebar/>
      <div className="creation-main-content">
        <Navbar/>
        <div className="page-header-section">
          <div className="header-card">
            <div className="header-content">
              <h1 className="page-title">{title}</h1>
              <div className="page-subtitle">Create a new user account with role permissions</div>
            </div>
            <div className="header-actions">
              <button type="button" className="action-btn-secondary" onClick={handleReset}>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M2 2L10 10M10 2L2 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                Clear Form
              </button>
            </div>
          </div>
        </div>
        
        <div className="form-creation-section">
          <div className="creation-form-card">
            <div className="form-header">
              <h2 className="form-title">User Information</h2>
              <div className="form-description">Fill in the details below to create a new user account</div>
            </div>
            
            <form className="user-creation-form">
              <div className="form-fields-grid">
                {inputs.map((input) => (
                  <div className="field-group" key={input.id}>
                    <label className="field-label">{input.label}</label>
                    <div className="field-input-wrapper">
                      <input
                        className="modern-input"
                        onChange={handleChange}
                        type={input.type}
                        placeholder={input.placeholder}
                        id={input.id}
                        value={info[input.id] || ''}
                      />
                    </div>
                  </div>
                ))}
                
                <div className="field-group role-selection">
                  <label className="field-label">User Access Level</label>
                  <div className="select-field-wrapper">
                    <select 
                      className="modern-select" 
                      id="isAdmin" 
                      onChange={handleChange}
                      value={info.isAdmin || 'false'}
                    >
                      <option value="false">Standard User</option>
                      <option value="true">Administrator</option>
                    </select>
                    <div className="select-icon">
                      <svg width="12" height="7" viewBox="0 0 12 7" fill="none">
                        <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="form-submit-section">
                <div className="submit-actions">
                  <button 
                    type="button" 
                    className="cancel-btn" 
                    onClick={() => navigate("/users")}
                  >
                    Cancel
                  </button>
                  <button 
                    type="button" 
                    className="create-user-btn" 
                    onClick={handleClick}
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M8 1V15M1 8H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    Create User
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default New